<template>
  <div class="add-product">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="appFirmware.id ? $t('upgrade.editFirmware') : $t('upgrade.addFirmware')"
      :visible.sync="dialogFirmware"
      width="40%"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form
          :label-position="labelPosition"
          :rules="rules"
          ref="appFirmware"
          label-width="80px"
          :model="appFirmware"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('upgrade.addFirmware')" prop="url">
                <el-upload
                  class="upload-demo"
                  :action="appUploadUrl"
                  :headers="headers"
                  :on-success="appSuccess"
                  :on-error="appError"
                  :on-remove="handleRemove"
                  :limit="1"
                  :multiple="false"
                  :accept="'.bin'"
                  :before-upload="handleBefore"
                  :file-list="appFileList"
                >
                  <el-button slot="trigger" size="small" type="primary">{{ $t("addAppVersion.trigger") }}</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('upgrade.firmwareId')" prop="version">
                <el-input
                  v-model="appFirmware.version"
                  :placeholder="$t('upgrade.pVersion')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('upgrade.notes')">
                <el-input type="textarea" :rows="4" v-model="appFirmware.notes"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm('appFirmware')">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import config from "@/http/config";
  export default {
    name: "AppFirmware",
    props: {
      appFirmware: Object,
      dialogFirmware: Boolean
    },
    data() {
      return {
        labelPosition: "top",
        rules: {
          url: [
            {
              required: true,
              message: this.$t("upgrade.rDownUrl"),
              trigger: "blur"
            }
          ],
          version: [
            {
              required: true,
              message: this.$t("upgrade.pVersion"),
              trigger: "blur"
            }
          ]
        },
        limit: 1,
        clear: false,
        loadingForm: false,
        headers: {
          token: this.$cookies.get("token")
        },
        appUploadUrl: config.baseUrl + this.$url.Upgrade.firmwareupload,
        appFileList: []
      };
    },
    methods: {
      handleBefore(file) {
        let fileName = file.name;
        this.appFirmware.fileName = fileName;
      },
      cancel(state, code) {
        this.$emit("cancel", false, state, code);
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loadingForm = true;
            let url = this.$url.Upgrade.firmwareInsert;
            let method = this.$method.post;
            if (this.appFirmware.id) {
              url = this.$url.Upgrade.firmwareupdate;
              method = this.$method.put;
            }
            // 前缀默认V
            this.appFirmware.prefix = "V";
            this.$api
              .request(url, method, this.appFirmware)
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  this.clear = true;
                  this.loadingForm = false;
                  this.cancel(this.appFirmware.id ? "update" : "save");
                }
              })
              .catch(err => {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: err.msg,
                  type: "error"
                });
                this.loadingForm = false;
              });
          }
        });
      },
      closeDialog() {
        this.clearValidate("appFirmware");
        if (this.appFirmware.id) {
          this.$toolUtil.clearForm(this.appFirmware);
        } else {
          if (this.clear) {
            this.$toolUtil.clearForm(this.appFirmware);
          }
        }
        this.cancel("");
        this.appFileList = [];
      },
      openDialog() {
        if (this.appFirmware.id) {
          if (this.appFileList.length <= 0 && this.appFirmware.url) {
            this.appFileList.push({
              name: this.appFirmware.fileName,
              url: this.appFirmware.url
            });
          }
        }
      },
      // 清除表单校验
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      },
      hideUpload() {
        this.$nextTick(() => {
          let card = window.document.querySelector(".el-upload--picture-card");
          card.style.display = "none";
        });
      },
      appSuccess(res) {
        if (res.code === 0) {
          this.appFirmware.url = res.data;
        } else {
          this.$message.error(res.msg);
        }
      },
      appError(err) {
        this.$message.error(err.msg ? err.msg : this.$t("addAppVersion.error"));
      },
      handleRemove() {
        this.appFirmware.url = "";
        this.appFirmware.fileName = "";
      }
    }
  };
</script>

<style lang="scss">
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
  .upload-app .el-upload__tip {
    line-height: 16px;
  }
</style>
